import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * This license gives somebody the right to declare trusted keys for this instance.
 *
 * The trust is given by creating a "TrustKeysCertificate" pointing to a profile that contains keys.
 *
 * Attention: This is a very very powerful right. Somebody with this right can impersonate
 * everybody else by just issuing new keys for that person.
 */
export const RightToDeclareTrustedKeysForEverybodyLicense = Object.freeze({
    $type$: 'License',
    name: 'RightToDeclareTrustedKeysForEverybodyLicense',
    description: '[signature.issuer] gives [beneficiary] the right to declare any keys in profiles as' +
        ' trusted by issuing TrustKeys certificates.'
});
registerLicense(RightToDeclareTrustedKeysForEverybodyLicense, 'RightToDeclareTrustedKeysForEverybodyCertificate');
export const RightToDeclareTrustedKeysForEverybodyCertificateRecipe = {
    $type$: 'Recipe',
    name: 'RightToDeclareTrustedKeysForEverybodyCertificate',
    rule: [
        {
            itemprop: 'beneficiary',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const RightToDeclareTrustedKeysForEverybodyCertificateReverseMap = ['RightToDeclareTrustedKeysForEverybodyCertificate', new Set(['*'])];
//# sourceMappingURL=RightToDeclareTrustedKeysForEverybodyCertificate.js.map